<template>
  <app-chip
    :class="[definition.class, { 'bg-transparent !p-0': flat }]"
    :icon="definition.icon"
    :size="size"
  >
    {{ definition.label }}
  </app-chip>
</template>

<script lang="ts" setup>
import { type I18nMessage } from "@pollen/core/model/i18n.model";

const properties = defineProps<{
  course: Pick<DatabaseTable<"courses">, "content_type">;
  size?: "small";
  flat?: boolean;
}>();

const definition = computed<{
  class: string;
  label: I18nMessage;
  icon: string;
}>(() => {
  if (properties.course.content_type === "MASTERCLASS")
    return {
      class: "bg-accent-50 text-accent-950",
      label: "Masterclass",
      icon: "ph:microphone-stage-duotone",
    };

  return {
    class: "bg-primary-50 text-primary-950",
    label: "Training",
    icon: "ph:graduation-cap-duotone",
  };
});
</script>
